import React from 'react';
import { motion } from 'framer-motion';
export function OriginStory() {
  return <section className="py-20 bg-white" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-112">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal leading-tight mb-6" data-id="element-113">
              They walked away from a great paycheck to build something better.
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-114">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-115">
              Co-founders Brock and Andres launched NTY Windows after walking
              away from a company where they had built five offices and helped
              grow sales from half a million to four million a month. The
              results were there, but the culture had changed.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-116">
              The company went corporate, and decisions started coming down that
              didn't line up with the way they wanted to lead. So they walked
              away.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-117">
              Almost immediately, the phone was blowing up — people asking where
              they were going and what they were building next. The answer was
              something better:{' '}
              <strong className="text-maroon" data-id="element-118">
                a company built around real accountability, high standards, and
                a team culture that makes people want to show up and win.
              </strong>
            </p>

            <div className="pt-6 flex items-center space-x-4" data-id="element-119">
              <div className="flex -space-x-3" data-id="element-120">
                <div className="w-16 h-16 rounded-full bg-maroon flex items-end justify-center overflow-hidden border-2 border-white shadow-md" data-id="element-121">
                  <img src="https://cdn.magicpatterns.com/uploads/cFbouvAsfYfCXFGic1pehP/6.png" alt="Brock, Co-Founder" className="w-full h-full object-cover object-top scale-110" data-id="element-122" />
                </div>
                <div className="w-16 h-16 rounded-full bg-charcoal flex items-end justify-center overflow-hidden border-2 border-white shadow-md" data-id="element-123">
                  <img src="https://cdn.magicpatterns.com/uploads/4hhqMhVo677mhhQYCvYizi/5.png" alt="Andres, Co-Founder" className="w-full h-full object-cover object-top scale-110" data-id="element-124" />
                </div>
              </div>
              <div data-id="element-125">
                <div className="font-bold text-charcoal" data-id="element-126">Brock & Andres</div>
                <div className="text-sm text-gray-600" data-id="element-127">Co-Founders</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}